<template>
  <div class="full-height">
    <div
      width="100%"
      rounded="0"
      class="full-height"
      id="audit-claims"
      :class="!isMobile ? 'd-flex flex-column' : ''"
    >
      <div>
        <Header
          title="Admin Claims"
          icon="mdi-loupe"
          iconColor="brand"
          :showSearch="false"
          :showAddClient="false"
        />
      </div>
      <v-card
        class="d-flex flex-column mt-3 pa-3"
        :class="{
          'mb-4': !isMobile,
          'mx-1': isMobile,
        }"
        id="advanced-filters"
      >
        <v-tabs v-model="activeTab" color="brandPrimary">
          <v-tab v-if="showAuditTab">Audit</v-tab>
          <v-tab v-if="showBulkUploadTab">Bulk Upload</v-tab>
        </v-tabs>
        <v-divider />

        <v-tabs-items v-model="activeTab">
          <v-tab-item v-if="showAuditTab">
            <AuditClaimsTab />
          </v-tab-item>

          <v-tab-item v-if="showBulkUploadTab">
            <AdminBulkUploadTab />
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import AuditClaimsTab from "@/components/program/admin/audit-claims/AuditClaimsTab.vue";
import AdminBulkUploadTab from "@/components/program/admin/bulk-upload/AdminBulkUploadTab.vue";
import { mapState } from "vuex";

export default {
  name: "AdminClaims",
  title: "Admin Claims",
  components: {
    Header,
    AuditClaimsTab,
    AdminBulkUploadTab,
  },
  data: () => ({
    activeTab: 0,
  }),
  computed: {
    ...mapState(["permissions", "featureFlags"]),
    isMobile() {
      return this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm;
    },
    permissionList() {
      return Array.isArray(this.permissions) ? this.permissions : [];
    },
    showAuditTab() {
      return this.permissionList.includes("vue:read:audit-claims");
    },
    showBulkUploadTab() {
      return (
        this.permissionList.includes("vue:read:bulk-upload-claims") &&
        !!this.featureFlags?.["feature-admin-bulk-submissions"]
      );
    },
  },
  watch: {
    showBulkUploadTab(isVisible) {
      if (!isVisible) {
        this.activeTab = 0;
      }
    },
  },
};
</script>

<style scoped>
#audit-claims .card-col.col {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-dash {
  text-align: center;
  font-size: 1.5em;
  margin-bottom: 1.2em;
}
</style>
